export const TRAINING_VALIDATION_CONTEXT = {
    ifChecked: {
        hasNoTraining: `Please select 'Add training'`
    },
    trainedCheck: {
        hasNoTraining: `Unselect 'I do not have any formal training' first, before selecting 'Add training'`
    },
}